var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.122,
    height: 12.812,
    viewBox: "0 0 18.122 12.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16352",
    "data-name": "Grupo 16352",
    transform: "translate(-102 -39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41366",
    "data-name": "Caminho 41366",
    d: "M116.827,39H105.295A3.1,3.1,0,0,0,102,41.847v7.118a3.1,3.1,0,0,0,3.295,2.847h11.532a3.1,3.1,0,0,0,3.295-2.847V41.847A3.1,3.1,0,0,0,116.827,39Zm0,1.424a1.549,1.549,0,0,1,1.647,1.424v7.118a1.549,1.549,0,0,1-1.647,1.424H105.295a1.549,1.549,0,0,1-1.647-1.424V41.847a1.549,1.549,0,0,1,1.647-1.424Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41367",
    "data-name": "Caminho 41367",
    d: "M111.289,49.209l-8-6.909,1.165-1.006,6.831,5.9,6.831-5.9,1.165,1.006Z",
    transform: "translate(-0.228 -0.661)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8d07afc33fdd9592571317ab8572272f.svg";
export { ForwardRef as ReactComponent };